/**
 * Toggle to preview the tactics UI without API calls.
 * Set to false when wiring to the live backend.
 */
export const USE_TACTICS_PREVIEW_DATA = true;

export const MOCK_MATCH_INFO = {
  teamName: "Westlands Hoops",
  opponentName: "Nairobi City BC",
  matchDate: "2026-06-15T18:00:00.000Z",
};

export const MOCK_TEAM_ID = 1;
export const MOCK_MATCH_ID = 101;

/** Roster for 5v5 preview (starters + bench). */
export const MOCK_BASKETBALL_PLAYERS = [
  { id: 100001, name: "James Otieno", position: "PG", number: 1 },
  { id: 100002, name: "Brian Kamau", position: "SG", number: 3 },
  { id: 100003, name: "David Mwangi", position: "SF", number: 7 },
  { id: 100004, name: "Kevin Ochieng", position: "PF", number: 11 },
  { id: 100005, name: "Eric Wanjala", position: "C", number: 15 },
  { id: 100006, name: "Samuel Kiprop", position: "PG", number: 2 },
  { id: 100007, name: "Ian Mutua", position: "SG", number: 5 },
  { id: 100008, name: "Victor Odhiambo", position: "SF", number: 9 },
  { id: 100009, name: "Tony Kimani", position: "PF", number: 13 },
  { id: 100010, name: "Chris Maina", position: "C", number: 21 },
  { id: 100011, name: "Alex Njeri", position: "SG", number: 8 },
  { id: 100012, name: "Peter Ouma", position: "PF", number: 14 },
];

export function shouldUseTacticsPreview(route) {
  if (!USE_TACTICS_PREVIEW_DATA) return false;
  if (route?.query?.preview === "0" || route?.query?.live === "1") return false;
  if (route?.name === "BasketballTacticsPreview") return true;
  if (route?.query?.preview === "1") return true;
  return USE_TACTICS_PREVIEW_DATA;
}
